import { useEffect, useState } from "react";
import "./Cookies.css";

const GA_ID = "G-LC38VP2W6D"; 

function loadGoogleAnalytics() {
  if (!GA_ID || window.gtag) return;

  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag("js", new Date());
  gtag("config", GA_ID);
}

export default function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookiesConsent");
    if (!consent) {
      setShowBanner(true);
    } else if (consent === "accepted") {
      loadGoogleAnalytics();
    }
  }, []);

  const aceitarCookies = () => {
    localStorage.setItem("cookiesConsent", "accepted");
    loadGoogleAnalytics();
    setShowBanner(false);
  };

  const recusarCookies = () => {
    localStorage.setItem("cookiesConsent", "rejected");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner">
      <p>
        Usamos cookies para melhorar sua experiência e analisar o tráfego.{" "}
        <a href="/politica-de-privacidade" target="_blank" rel="noopener noreferrer">
          Saiba mais
        </a>.
      </p>
      <div className="cookie-buttons">
        <button onClick={aceitarCookies}>Aceitar</button>
        <button onClick={recusarCookies} className="btn-recusar">
          Recusar
        </button>
      </div>
    </div>
  );
}
